export default __webpack_public_path__ + "static/media/pxlhnsDDS.709b96d9.png";